import { render, staticRenderFns } from "./edit-sub-task-form.vue?vue&type=template&id=13ed39e8&"
import script from "./edit-sub-task-form.vue?vue&type=script&lang=js&"
export * from "./edit-sub-task-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports